<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li class="active">重新绑定</li>
      </ul>
    </div>
    <div class="member-main-body">
      <div class="modify-title">修改手机号</div>
      <div class="modify-code">
        <Input
          v-model="phoneCode"
          placeholder="请输入验证码"
          size="large"
          style="position: relative; width: 160px; z-index: 1"
        />
        <Button
          type="warning"
          size="large"
          :disabled="phoneCodeDisabled"
          @click="getPhoneCode"
          style="
            position: relative;
            margin-left: -10px;
            width: 120px;
            z-index: 2;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          "
          >{{ phoneCodeText }}</Button
        >
      </div>
      <div class="modify-tips">
        点击获取验证码按扭，请输入{{ cellphone }}收到的短信验证码
      </div>
      <div class="modify-btn">
        <Button
          type="primary"
          size="large"
          shape="circle"
          long
          @click="checkPhoneCode"
          >下一步</Button
        >

        <Button
          type="default"
          size="large"
          shape="circle"
          long
          :to="{ name: 'Account' }"
          style="margin-top: 24px"
          >上一步</Button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import { account } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      phoneCode: "",
      phoneCodeText: "获取验证码",
      phoneCodeDisabled: false,
    };
  },
  computed: {
    cellphone() {
      return this.loginUser.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
  },
  methods: {
    getPhoneCode() {
      if (!this.isRequest) {
        if (!this.loginUser.mobile) return;
        this.isRequest = true;
        account
          .getPhoneCode(this.loginUser.mobile, this.loginUser.userId)
          .then((result) => {
            if (result.status == 1) {
              let second = 60;
              let timer = setInterval(() => {
                second--;
                this.phoneCodeText = `还剩 ${second} 秒`;
                if (second === 0) {
                  this.phoneCodeText = "重新获取";
                  this.isRequest = false;
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.$Message.error(result.message);
            }
          });
      }
    },
    checkPhoneCode() {
      if (!this.phoneCode) {
        this.$Message.error("请输入手机验证码");
        return;
      }
      account
        .checkPhoneCode(this.loginUser.mobile, this.phoneCode)
        .then((res) => {
          if (res.status === 1) {
            this.$router.push({ name: "AccountBindPhone" });
          } else {
            this.$Message.error(res.message);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/var";
@import "../../assets/css/member-main.less";
.member-main-body {
  position: relative;
  padding: 30px;
}
.modify-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;
}
.modify-tips {
  font-size: 14px;
  margin-top: 10px;
  color: #999;
}
.modify-btn {
  margin-top: 20px;
  width: 300px;
}
</style>